// extracted by mini-css-extract-plugin
export default {"list":"link-list_list__udWht","item":"link-list_item__mcKuC","link":"link-list_link__IyyQa","link_active":"link-list_link_active__-7qOu"};